<fgb-page-header
  [pageTitle]="'rewards.page.title'"
  [showBanner]="true"
  [backButtonLink]="'/'"
  [kidsBanner]="'banners/kids-rewards.jpg'"
></fgb-page-header>
<!--Sub Nav-->
<div class="container">
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
</div>

<div class="container mt-3">
  <fgbcl-marketplace-list-v2
    [isList]="true"
    [marketplaceItemView]="true"
    [marketplaceItemTypes]="[3, 5]"
    [defaultSort]="2"
  ></fgbcl-marketplace-list-v2>
</div>
